import { MutationTree } from 'vuex'
import {
  ConsultoryItem,
  ConsultoryState,
  ModulesResponse,
  ModuleDoctorItem,
  ModuleScheduleItem,
  LoadingScheduleDay,
  EventItem
} from '@/store/consultories/types'
import { Doctor } from '@/store/doctor/types'

export enum ConsultoryMutations {
  SET_PROFILE_CONSULTORIES = 'SET_PROFILE_CONSULTORIES',
  SET_LOADER_CREATE_CONSULTORY = 'SET_LOADER_CREATE_CONSULTORY',
  SET_LOADER_CONSULTORIES_LIST = 'SET_LOADER_CONSULTORIES_LIST',
  SET_LOADER_MODULES = 'SET_LOADER_MODULES',
  SET_MODULES_LIST = 'SET_MODULES_LIST',
  SET_LOADER_DOCTORS_LIST = 'SET_LOADER_DOCTORS_LIST',
  SET_DOCTORS_LIST = 'SET_DOCTORS_LIST',
  SET_LOADER_SEARCH_DOCTOR = 'SET_LOADER_SEARCH_DOCTOR',
  SET_DOCTOR_SEARCH = 'SET_DOCTOR_SEARCH',
  SET_MODULE_SCHEDULE = 'SET_MODULE_SCHEDULE',
  SET_MODULE_SCHEDULE_LOADER = 'SET_MODULE_SCHEDULE_LOADER',
  SET_LOADER_SCHEDULE_DAY = 'SET_LOADER_SCHEDULE_DAY',
  SET_MODULE_EVENTS = 'SET_MODULE_EVENTS',
  SET_LOADER_MODULE_EVENTS = 'SET_LOADER_MODULE_EVENTS'
}

export const mutations: MutationTree<ConsultoryState> = {
  // MUTATIONS FOR CONSULTORIES
  [ConsultoryMutations.SET_LOADER_CONSULTORIES_LIST](
    state: ConsultoryState,
    payload: boolean
  ) {
    state.loadingConsultoriesList = payload
  },

  [ConsultoryMutations.SET_LOADER_CREATE_CONSULTORY](
    state: ConsultoryState,
    payload: boolean
  ) {
    state.loadingCreateConsultory = payload
  },

  [ConsultoryMutations.SET_PROFILE_CONSULTORIES](
    state: ConsultoryState,
    list: Array<ConsultoryItem>
  ) {
    state.consultoriesList = list
  },

  // MUTATIONS FOR CONSULTATION MODULES
  [ConsultoryMutations.SET_LOADER_MODULES](
    state: ConsultoryState,
    payload: boolean
  ) {
    state.loadingConsultoryModules = payload
  },

  [ConsultoryMutations.SET_MODULES_LIST](
    state: ConsultoryState,
    modules: ModulesResponse
  ) {
    state.modules = modules
  },

  [ConsultoryMutations.SET_LOADER_DOCTORS_LIST](
    state: ConsultoryState,
    payload: boolean
  ) {
    state.loadingDoctors = payload
  },

  [ConsultoryMutations.SET_DOCTORS_LIST](
    state: ConsultoryState,
    doctors: Array<ModuleDoctorItem>
  ) {
    state.doctors = doctors
  },

  [ConsultoryMutations.SET_LOADER_SEARCH_DOCTOR](
    state: ConsultoryState,
    payload: boolean
  ) {
    state.loadingSerachDoctor = payload
  },

  [ConsultoryMutations.SET_DOCTOR_SEARCH](
    state: ConsultoryState,
    doctor: Doctor | null
  ) {
    state.doctorSearch = doctor
  },

  //Module's schedule
  [ConsultoryMutations.SET_MODULE_SCHEDULE](
    state: ConsultoryState,
    payload: Array<ModuleScheduleItem>
  ) {
    state.moduleSchedule = payload
  },

  [ConsultoryMutations.SET_MODULE_SCHEDULE_LOADER](
    state: ConsultoryState,
    payload: boolean
  ) {
    state.loadingModuleSchedule = payload
  },

  [ConsultoryMutations.SET_LOADER_SCHEDULE_DAY](
    state: ConsultoryState,
    payload: LoadingScheduleDay
  ) {
    state.loadingScheduleDay = payload
  },

  [ConsultoryMutations.SET_LOADER_MODULE_EVENTS](
    state: ConsultoryState,
    payload: boolean
  ) {
    state.loadingEvents = payload
  },

  [ConsultoryMutations.SET_MODULE_EVENTS](
    state: ConsultoryState,
    events: Array<EventItem>
  ) {
    state.moduleEvents = events
  }
}
